import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {Avatar} from 'antd'
import { AuthContext } from '../../Context';

DisplayAvatar.propTypes = {
      photoURL: PropTypes.string,
};
DisplayAvatar.defaultProps={
      photoURL:''
}

function DisplayAvatar(props) {
      const [hideAvatarUser, setHideAvatarUser]= useState('');
      const {photoURL} = props;
      const {user} = useContext(AuthContext);
      useEffect(()=>{
            async function handleHideAvatarUser(){
                 if(user.photoURL===photoURL)
                        setHideAvatarUser('none');
                        return;
            }
            handleHideAvatarUser();
      },[photoURL, user.photoURL])
      return (
            <Avatar style={{display:hideAvatarUser}} src={photoURL}>    
            </Avatar>
      );
}

export default DisplayAvatar;